export default "/assets/images/mama-room3.png?097274ee186124978740cc69ae765da2";